'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { earnSummaryBunja } from '@flipster/features/src/shared/earn/state';
import { css } from '@flipster/styled-system/css';
import { hstack, stack, vstack } from '@flipster/styled-system/patterns';

import InactiveAprCard from './inactive-apr-card';

const BeforeParticipationEarnAprSection = () => {
  const { earnSummaryAtom } = useBunja(earnSummaryBunja);
  const earnSummary = useAtomValue(earnSummaryAtom);

  return (
    <section className={stack({ gap: 20 })}>
      <div className={hstack({ justify: 'space-between' })}>
        <div className={stack({ gap: 4 })}>
          <p className={css({ textStyle: 'Title/M', color: 'content.default.level-4' })}>Deposit and start earning</p>
          <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-2' })}>
            Earn and trade seamlessly. Grow your balance while you trade.
          </p>
        </div>
      </div>

      <div className={vstack({ alignItems: 'stretch', gap: 10 })}>
        {earnSummary?.currencies.map((c) => <InactiveAprCard key={c.currency} currency={c.currency} />)}
      </div>
    </section>
  );
};

export default BeforeParticipationEarnAprSection;
